import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that redirects to login if user is not authenticated.
 * Preserves the attempted URL so the user returns there after login.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // While checking auth state, show nothing (prevents flash of login page)
  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search + location.hash;
    const loginUrl = returnTo === '/' ? '/login' : `/login?returnTo=${encodeURIComponent(returnTo)}`;
    return <Navigate to={loginUrl} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;